import React, { PropsWithChildren, FunctionComponent, ReactElement } from "react";
import { Icon, Message, SemanticICONS } from "semantic-ui-react";

import "./Chip.css";

interface ChipProps extends PropsWithChildren {
  className?: string;
  positive?: boolean;
  negative?: boolean;
  icon?: SemanticICONS | ReactElement;
  onClick?: () => void;
}

export const Chip: FunctionComponent<ChipProps> = ({
  icon,
  children,
  ...rest
}) => {
  return (
    <Message
      className="chip"
      {...rest}
    >
      <Message.Content>
        {typeof icon === "string" ? (
          <Icon
            name={icon}
            size="small"
          />
        ) : (
          icon
        )}
        <span>
          {children}
        </span>
      </Message.Content>
    </Message>
  );
};
